import { orUndefined, schAloftPrice } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { selectEstimatedROI } from '../../../redux/features/selectors/selectEstimatedROI.ts';
import { selectReconciliation } from '../../../redux/features/selectors/selectReconciliation.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

export const EstimatedROIBanner = () => {
  const estimatedROI = useAppSelector(selectEstimatedROI);
  const {
    includeTotalRenovationBudget,
    opinionOfAfterRepairValue,
    opinionOfMarketValue,
    totalRenovationBudget,
  } = useAppSelector(selectReconciliation);

  const estimatedROIDisplay = `Estimated Return on Investment: ${estimatedROI?.toString(true)}`;
  const opinionOfAfterRepairValueDisplay = `After-Repair Value: ${orUndefined(schAloftPrice.parse)(
    opinionOfAfterRepairValue,
  )?.toString(true)}`;
  const totalRenovationBudgetDisplay = `Renovation Budget: ${orUndefined(schAloftPrice.parse)(
    totalRenovationBudget,
  )?.toString(true)}`;
  const opinionOfMarketValueDisplay = `Market Value: ${orUndefined(schAloftPrice.parse)(
    opinionOfMarketValue,
  )?.toString(true)}`;

  const color = estimatedROI && estimatedROI.toDollarLike() <= 0 ? 'textError' : 'textSuccess';

  if (
    !estimatedROI ||
    !opinionOfAfterRepairValue ||
    !opinionOfMarketValue ||
    (includeTotalRenovationBudget && !totalRenovationBudget)
  ) {
    return <Flex flexGrow={1} />;
  }

  const equationWithRenovationBudget = `${opinionOfAfterRepairValueDisplay} - (${totalRenovationBudgetDisplay} + ${opinionOfMarketValueDisplay})`;
  const equationWithoutRenovationBudget = `${opinionOfAfterRepairValueDisplay} - ${opinionOfMarketValueDisplay}`;

  const equation = includeTotalRenovationBudget
    ? equationWithRenovationBudget
    : equationWithoutRenovationBudget;

  return (
    <Flex flexWrap="nowrap" flexGrow={1}>
      <Typography variant="h3" color={color} __dangerDoNotUseSx={{ whiteSpace: 'nowrap' }}>
        {estimatedROIDisplay}
      </Typography>
      <Typography variant="h3" __dangerDoNotUseSx={{ whiteSpace: 'nowrap' }}>
        &nbsp;≈&nbsp;{equation}
      </Typography>
    </Flex>
  );
};
